import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { backendMode } from './data/backend/mode.js';
import { initTheme } from './theme.js';
import './styles.css';

function Booting({ label }) {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', color: 'var(--ink-3)' }}>
      {label}
    </div>
  );
}

// Lazy so the Supabase SDK stays out of the demo's bundle entirely.
const AuthGate = lazy(() => import('./auth/gate.jsx'));

initTheme();

const useSupabase = backendMode() === 'supabase';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <HashRouter>
        {useSupabase ? (
          <Suspense fallback={<Booting label="Starting…" />}>
            <AuthGate />
          </Suspense>
        ) : (
          <App />
        )}
      </HashRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
